<template>
    <div class="login-body">
        <div class="login-form">
            <div v-if="lastAuthMessage" class="login-message-wrapper">
                <div class="login-message" :class="{ notification: lastAuthNotification }">
                    {{ lastAuthMessage }}
                    <span class="login-message-close">
                        <i class="icon-close" @click="clearMessage"></i>
                    </span>
                    <div v-if="lastAuthSubMessage" class="login-sub-message">
                        {{ lastAuthSubMessage }}
                    </div>
                </div>
            </div>
            <div class="login-header">
                <img src="static/img/logo.svg" alt="ascom" width="92" height="37" />
                <h3>Messaging Assignments Reporting Interface</h3>
            </div>
            <div class="login-progress-bar">
                <div class="login-progress-state" :style="{ width: loginProgress + '%' }"></div>
            </div>
            <div class="login-footer">
                <form id="forAT-FormLogin">
                    <div class="login-wrapper">
                        <span v-if="sendAttempt && $v.username.$invalid" class="tooltiptext">
                            {{ $t('login.usernameError') }}
                        </span>
                        <input
                            id="forAT_Login-username"
                            ref="username"
                            v-model="username"
                            v-focus-inserted
                            type="text"
                            name="Username"
                            :placeholder="$t('login.username')"
                            class="login-input"
                            :class="{ tooltiperror: sendAttempt && $v.username.$invalid }"
                            :disabled="isInProgress"
                        />
                    </div>
                    <div class="login-wrapper">
                        <span v-if="sendAttempt && $v.password.$invalid" class="tooltiptext">
                            {{ $t('login.passwordError') }}
                        </span>
                        <input
                            id="forAT_Login-password"
                            v-model="password"
                            type="password"
                            name="Password"
                            :placeholder="$t('login.password')"
                            class="login-input"
                            :class="{ tooltiperror: sendAttempt && $v.password.$invalid }"
                            :disabled="isInProgress"
                        />
                    </div>
                    <button class="btn login-button" :disabled="isInProgress" @click.prevent="submitForm">
                        <i class="icon-arrow-right"></i>{{ $t('login.loginButton') }}
                    </button>
                    <!--<select-box style-class="inline" :options="getLanguages()"-->
                    <!--v-model="language" :placeholder="language" :search="false">-->
                    <!--</select-box>-->
                </form>
            </div>
        </div>

        <Loader :visible="isLoading" css-class="login-large-loader-wrapper" />
    </div>
</template>

<script type="text/babel">
import Loader from './components/common/Loader.vue';
import SelectBox from './components/common/SelectBox.vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import commonDirectives from './components/common/commonDirectives';

export default {
    components: {
        SelectBox,
        Loader,
    },

    mixins: [commonDirectives],

    data() {
        return {
            isLoading: false,
            sendAttempt: false,
            username: '',
            password: '',
        };
    },

    computed: {
        ...mapState('user', ['user', 'lastAuthError', 'lastAuthNotification', 'loginProgress']),

        lastAuthMessage() {
            return this.lastAuthError || (this.lastAuthNotification && this.lastAuthNotification.title);
        },

        lastAuthSubMessage() {
            return this.lastAuthNotification && this.lastAuthNotification.message;
        },

        isInProgress() {
            return this.loginProgress > 0;
        },
    },

    watch: {
        isInProgress() {
            this.$nextTick(() => {
                this.$refs.username.select();
            });
        },
    },

    methods: {
        ...mapActions('user', ['login']),

        ...mapMutations({
            clearErrorMessage: 'user/CLEAR_ERROR',
            setErrorMessage: 'user/SET_ERROR',
            clearNotificationMessage: 'user/CLEAR_NOTIFICATION',
        }),

        clearMessage() {
            this.clearErrorMessage();
            this.clearNotificationMessage();
        },

        submitForm() {
            if (!this.isInProgress) {
                this.clearMessage();
                this.sendAttempt = true;
                if (this.$v.$invalid) {
                    this.setErrorMessage(this.$t('login.enterUsernamePassword'));
                } else {
                    this.login({ username: this.username, password: this.password });
                }
            }
        },

        /*        getLanguages() {
                let languageOptionsList = [];
                for (let i in window.languages) {
                    if (window.languages.hasOwnProperty(i)) {
                        languageOptionsList.push({
                            name: i,
                            value: i,
                        });
                    }
                }

                return languageOptionsList;
            },*/
    },

    validations() {
        return {
            username: { required },
            password: { required },
        };
    },
};
</script>
